
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Projekt Gemini',
	'appExit': 'Przejdź do strony powitalnej',


	'widgetsListLabel': 'Lista widgetów. Wybierz widget i naciśnij klawisz enter, aby go dodać.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Aktualne',
	'dirty': 'Nieaktualne',
	'conflict': 'Konflikt przy zapisywaniu widoku',
	'error': 'Problem przy zapisywaniu widoku',
	'failure': 'Nie można połączyć się z serwerem',
	'saveFailed': 'Nie można zapisać widoku',

	'wa_insync': 'Zapisano',
	'wa_conflict': 'Konflikt przy zapisywaniu widoku',
	'wa_error': 'Nie można zapisać widoku',
	'wa_failure': 'Nie można połączyć się z serwerem',

	// Menu Labels
	'changeDisplay': 'Zmień sposób wyświetlania',
	'changeToColumnChart': 'Zmień na wykres kolumnowy',
	'changeToBubbleChart': 'Zmień na wykres bąbelkowy',
	'toggleMoveHandles': 'Włącz/wyłącz uchwyty przesuwania',
	'undo': 'Cofnij',
	'redo': 'Ponów',
	'mode': 'Zmień tryb',

	'untitled': 'Bez tytułu',
	'remove': 'Usuń',
	'editTitle': 'Edytuj tytuł',
	'edit': 'Edytuj',
	'done': 'Gotowe',

	// Data tray
	'dataTrayHandleOpenLabel': 'Otwórz panel danych',
	'dataTrayHandleCloseLabel': 'Zamknij panel danych',

	// Dialogs
	'dlg_loading': 'Ładowanie...',
	'dlg_ok': 'OK',
	'dlg_create': 'Utwórz',
	'dlg_cancel': 'Anuluj',
	'dlg_close': 'Zamknij',
	'dlg_update': 'Aktualizuj',
	'dlg_renameBoardTitle': 'Zmień nazwę tego obiektu',
	'dlg_renameDatasetTitle': 'Zmień nazwę tego zestawu danych',
	'dlg_renameSceneTitle': 'Zmień nazwę tej sceny',
	'dlg_NameLabel': 'Nazwa:',
	'dlg_NewNameLabel': 'Nowa nazwa:',
	'dlg_DefaultNameWithDataSet': 'Widok %{name}',
	'dlg_ShareTitle': 'Udostępnij treść',
	'dlg_UnshareTitle': 'Usuń udostępnienie treści',
	'dlg_ShareUser': 'Identyfikator użytkownika:',
	'dlg_NewColumnLabel': 'Nazwa nowego obliczenia',

	'dlg_new': 'Nowy...',
	'dlg_open': 'Otwórz...',
	'dlg_makeACopy': 'Utwórz kopię',
	'dlg_rename': 'Zmień nazwę...',
	'dlg_moreToCome': 'Więcej czynności...',

	'dlg_use': 'Użyj',

	'dlg_RelinkDatasetTitle': 'Zastąp zestaw danych \'%{datasetName}\' zestawem...',

	'open_error': 'Podczas otwierania widoku wystąpił problem.',

	// Delete Board
	'del_dialogTitle': 'Potwierdź usunięcie',
	'del_itemMsg': 'Czy na pewno chcesz usunąć \'%{name}\'?',
	'del_itemsMsg': 'Czy na pewno chcesz usunąć pozycje w liczbie %{count}?',
	'del_deleteErr': 'Nie można usunąć \'%{name}\'',

	// List Sorting
	'dlg_ascending': 'rosnąco',
	'dlg_descending': 'malejąco',
	'dlg_custom': 'niestandardowe',
	'dlg_none': 'brak',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Szukaj',

	'searchHint': 'Szukaj we wszystkich swoich danych',
	'clearSearchResult': 'Wyczyść wyniki wyszukiwania',
	// Shapes and shapes categories
	// Basic shapes
	'shapesBasicShapesCat': 'Podstawowe',
	'shapesCircle': 'Okrąg',
	'shapesHexagon': 'Sześciokąt',
	'shapesLine': 'Linia',
	'shapesOctagon': 'Ośmiokąt',
	'shapesPentagon': 'Pięciokąt',
	'shapesSquare': 'Kwadrat',
	'shapesTriangle': 'Trójkąt',
	'shapesDiamond': 'Romb',
	'shapesTitle': 'Właściwości kształtu',


	// Advanced shapes
	'shapesAdvancedShapesCat': 'Zaawansowane',
	'shapesSquareRounded': 'Zaokrąglony kwadrat',
	'shapesStar': 'Gwiazda',
	'shapesChevron': 'Szewron',
	'shapesBadge_ribbon': 'Wstążka z odznaką',
	'shapesBadge': 'Wstążka',
	'shapesHeart': 'Serce',
	'shapesExclamation': 'Wykrzyknik',
	'shapesTrendingup': 'Trend w górę',
	'shapesTrendingdown': 'Trend w dół',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Ludzie',
	'shapesFemale': 'Kobieta',
	'shapesHappyface': 'Zadowolona twarz',
	'shapesMale': 'Mężczyzna',
	'shapesMan': 'Człowiek',
	'shapesNeutralface': 'Twarz o neutralnym wyrazie',
	'shapesSadface': 'Smutna twarz',
	'shapesShakehands': 'Uścisk dłoni',
	'shapesThumbsdown': 'Kciuk w dół',
	'shapesThumbsup': 'Kciuk w górę',
	'shapesWoman': 'Kobieta',

	// Weather and places
	'shapesPlacesWeatherCat': 'Miejsca i pogoda',
	'shapesCity': 'Miasto',
	'shapesCloud': 'Chmury',
	'shapesEducation': 'Edukacja',
	'shapesGovernment': 'Administracja',
	'shapesHalfcloud': 'Pół chmury',
	'shapesHouse': 'Dom',
	'shapesMoon': 'Księżyc',
	'shapesRain': 'Deszcz',
	'shapesSunny': 'Słońce',

	//Vehicles
	'shapesVehiclesCat': 'Pojazdy',
	'shapesAirplane': 'Samolot',
	'shapesCar': 'Samochód',
	'shapesShip': 'Statek',
	'shapesShoppingcart': 'Wózek na zakupy',
	'shapesTrain': 'Pociąg',
	'shapesTruck': 'Ciężarówka',

	//Objects
	'shapesObjectsCat': 'Obiekty',
	'shapesBook': 'Podsumowanie',
	'shapesBriefcase': 'Teczka',
	'shapesCalendar': 'Kalendarz',
	'shapesCheck': 'Zaznaczenie',
	'shapesClock': 'Zegar',
	'shapesDesktop': 'Biurko',
	'shapesDocument': 'Dokument',

	'shapesFood': 'Jedzenie',
	'shapesGear': 'Koło zębate',
	'shapesHealth': 'Zdrowie',

	'shapesIdea': 'Pomysł',
	'shapesMobile': 'Urządzenie mobilne',
	'shapesMoney_bill': 'Banknot',
	'shapesMoney_coin': 'Moneta',
	'shapesPiggybank': 'Skarbonka',
	'shapesStackofpaper': 'Stos kartek',
	'shapesStickynote1': 'Karteczka 1',
	'shapesStickynote2': 'Karteczka 2',
	'shapesTarget': 'Cel',
	'shapesTool': 'Narzędzie',

	'shapesUmbrella': 'Parasol',

	'shapesBrain': 'Mózg',
	'shapesSkull': 'Czaszka',
	'shapesEye': 'Oko',

	// Arrows shapes
	'shapesArrowsCat': 'Strzałki',
	'shapesRightArrow': 'Strzałka w prawo',
	'shapesLeftArrow': 'Strzałka w lewo',
	'shapesDoubleArrow': 'Podwójna strzałka',
	'shapesCurvedArrow': 'Zakrzywiona strzałka',

	// Callouts shapes
	'shapesCalloutsCat': 'Dymki',
	'shapesRectCallout': 'Dymek',

	// Images
	'imageWidgetTitle': 'Widget obrazów',
	'imageTextLabel': 'Wklej adres URL i naciśnij Enter, aby go zapisać',
	'imgUrl': 'Adres URL obrazu',
	'imgPasteLink': 'Wklej adres URL i naciśnij Enter, aby go zapisać',
	'imgResizeToFit': 'Zmień rozmiar, aby dopasować do wielkości obrazu',
	'imgHeight': 'Wysokość:',
	'imgWidth': 'Szerokość:',
	'imgTransparency': 'Przezroczystość:',
	'imgMissingUrl': 'Brak adresu URL obrazu',
	'imgUrlValidationError': 'Adres URL obrazu jest niepoprawny',
	'imgUrlInvalidDomainError': 'Adres URL obrazu wskazuje na domenę, która nie została zatwierdzona przez administratora. Domeny zatwierdzone przez administratora to "%{domains}"',


	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Odtwórz',
	'dataPlayerValueListLabel': 'Wartości odtwarzacza danych',
	// Text Widget
	'textWidgetTitle': 'Widget tekstowy',
	'textStyle': 'Style',
	'textStyleDescription': 'Wstępnie sformatowane style tekstu',
	'textTitleStyle': 'Tytuł',
	'textTitleSmallStyle': 'Mały tytuł',
	'textSubtitleStyle': 'Podtytuł',
	'textBodyStyle': 'Treść',
	'textBodySmallStyle': 'Mała treść',
	'textCaptionStyle': 'Podpis',
	'textQuoteStyle': 'Cytat',
	'textQuoteSmallStyle': 'Mały cytat',
	'textResponsiveStyle': 'Automatycznie dopasuj rozmiar',
	'textAutoFontSize': 'Auto',
	'textFontFamilySubClassHairline': 'Włosowa',
	'textFontFamilySubClassThin': 'Cienka',
	'textFontFamilySubClassThinItalic': 'Cienka kursywa',
	'textFontFamilySubClassExtraLight': 'Bardzo delikatna',
	'textFontFamilySubClassExtraLightItalic': 'Bardzo delikatna kursywa',
	'textFontFamilySubClassLight': 'Delikatna',
	'textFontFamilySubClassLightItalic': 'Delikatna kursywa',
	'textFontFamilySubClassRegular': 'Zwykła',
	'textFontFamilySubClassRegularItalic': 'Zwykła kursywa',
	'textFontFamilySubClassItalic': 'Kursywa',
	'textFontFamilySubClassMedium': 'Średnia',
	'textFontFamilySubClassMediumItalic': 'Średnia kursywa',
	'textFontFamilySubClassHeavy': 'Najgrubsza',
	'textFontFamilySubClassHeavyItalic': 'Najgrubsza kursywa',
	'textFontFamilySubClassDemiBold': 'Półpogrubiona',
	'textFontFamilySubClassDemiBoldItalic': 'Półpogrubiona kursywa',
	'textFontFamilySubClassBold': 'Pogrubiona',
	'textFontFamilySubClassBoldItalic': 'Pogrubiona kursywa',
	'textFontFamilySubClassExtraBold': 'Bardzo pogrubiona',
	'textFontFamilySubClassExtraBoldItalic': 'Bardzo pogrubiona kursywa',
	'textFontFamilySubClassBlack': 'Ciemna',
	'textFontFamilySubClassBlackItalic': 'Ciemna kursywa',
	'textFontFamilySubClassStencil': 'Wzornik',
	'responsiveCoachmarkTitle': 'Automatyczna wielkość czcionki',
	'responsiveCoachmarkContents': 'Wielkość czcionki dobierana jest tak, by dopasować się do zmiany wielkości tego typu tekstu. Wielkość czcionki można określić we właściwościach tekstu.',

	'propText': 'Szczegóły tekstu',
	'propTextReturn': 'Właściwości tekstu',

	'textFontSize': 'Rozmiar czcionki',
	'textFontFamily': 'Rodzina czcionek',
	'textFontWeight': 'Grubość czcionki',

	// Widget Properties
	'propImageLink': 'Odsyłacz do obrazu',
	'propMissingURL': 'Wprowadź adres URL',
	'propImgTop': 'Właściwości obrazu',
	'propGeneralReturn': 'Właściwości ogólne',
	'propStyle': 'Ogólne',
	'propStyleReturn': 'Ogólne',
	'propFillColor': 'Kolor wypełnienia',
	'propTextColor': 'Kolor tekstu',
	'propBorderColor': 'Kolor krawędzi',
	'propMaintainAxisScales': 'Zachowaj skalę osi',
	'propShowItemLabel': 'Pokaż etykietę elementu',
	'propHideLegend': 'Ukryj legendę',
	'propColorPalette': 'Paleta',
	'propLegendPosition': 'Położenie legendy',
	'propHideAxisTitleLabels': 'Ukryj tytuły osi',
	'propLineColor': 'Kolor linii',
	'propBubbleColor': 'Kolor bąbelka',
	'propInterpolation': 'Wygładź linie',
	'propElementColor': 'Kolor elementu wizualizacji',
	'propSymbolShape': 'Kształt symbolu',
	'propHeatScalePalette': 'Znaczenie kolorów',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Ciemniejsze kolory oznaczają mniejsze wartości.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Ciemniejsze kolory oznaczają większe wartości.',
	'propImageDetails': 'Szczegóły obrazu',
	'propWebDetails': 'Szczegóły strony WWW',
	'propMediaDetails': 'Szczegóły multimediów',
	'propPasteLink': 'Wprowadź adres URL i naciśnij Enter',

	//Layout Properties
	'propPositionLabel': 'Pozycja',
	'propPositionXAxis': 'X',
	'propPositionYAxis': 'Y',
	'propResizeLabel': 'Wielkość',
	'propResizeWidth': 'Szerokość',
	'propResizeHeight': 'Wysokość',
	'propRotateLabel': 'Obróć',
	'propRotateAngle': 'Kąt',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Liczba ikon',
	'propScaleDescription': 'Wybierz liczbę ikon',
	'propScaleFew': 'Niska',
	'propScaleDefault': 'Domyślna',
	'propScaleMany': 'Wysoka',

	'mediaAriaLabel': 'wejściowy adres url',
	'ariaGroupLabel': 'Kategoria listy rozwijanej: %{cateoryLabel} element: %{itemLabel}. W celu rozwinięcia naciśnij klawisz DOWN. W celu nawigacji naciskaj klawisze UP i DOWN, a w celu zwinięcia naciśnij klawisz ESCAPE.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Ostatnie odświeżanie: upłynęło %{timeInterval}',
	'widgetTimer': 'Licznik czasu widgetu',

	// Theme colors
	'transparent': 'Brak koloru',
	'white': 'Biały',
	'lightGrey': 'Jasnoszary',
	'grey': 'Szary',
	'darkGrey': 'Ciemnoszary',
	'black': 'Czarny',
	'lightBlue': 'Jasnoniebieski',
	'blue': 'Niebieski',
	'darkBlue': 'Ciemnoniebieski',
	'yellow': 'Żółty',
	'orange': 'Pomarańczowy',
	'lime': 'Limonkowy',
	'green': 'Zielony',
	'peach': 'Brzoskwiniowy',
	'red': 'Czerwony',
	'violet': 'Fioletowy',
	'aqua': 'Morski',
	'purple': 'Fioletowy',
	'plum': 'Śliwkowy',

	//Theme Palette Label
	'paletteLabel': 'Paleta IBM %{number}',
	'heatPaletteLabel': 'Paleta natężeń IBM %{number}',
	'conditionalPaletteLabel': 'Paleta warunkowa IBM %{number}',
	'userPaletteColor_lightTheme': 'Paleta jasna IBM',
	'userPaletteColor_defaultTheme': 'Paleta domyślna IBM',
	'userPaletteColor_darkTheme': 'Paleta ciemna IBM',

	// Dashboard
	'propDashboardBackgroundColor': 'Kolor tła',
	'dataCache': 'Pamięć podręczna danych',
	'dataCache_on': 'Wł.',
	'dataCache_off': 'Bez pamięci podręcznej',
	'dataCache_auto': 'Automatycznie',
	'propLayoutPositioning': 'Rozmieszczenie elementów układu',
	'propLayoutRelative': 'Względne',
	'propLayoutAbsolute': 'Bezwzględne',
	'propLayoutPositioningCoachmarkTitle': 'Wybierz styl układu',
	'propLayoutPositioningCoachmarkContent': 'W układzie względnym wielkości i położenia widgetów są dopasowywane tak, aby zmieściły się one na ekranie. Widgety w układzie bezwzględnym są wyświetlane dokładnie w takiej postaci, w jakiej zostały umieszczone w widoku, niezależnie od wielkości ekranu.',
	'gridText': 'Pokaż siatkę',
	'snapText': 'Przyciągaj do siatki',
	'snapObjectsText': 'Przyciągaj do obiektów',
	'fitPageText': 'Dopasuj stronę',
	'gridLabel': 'Siatka',
	'heightUnit': 'w',
	'widthUnit': 'sz',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Rozmiar strony',
	'propPageSizePresetAriaLabel': 'Ustawienie rozmiaru strony',
	'propPageSizePreset': 'Ustawienie wstępne',
	'propPageSizePresetCustom': 'Niestandardowa',
	'propPageSizePreset16x9': 'Ekran 16:9',
	'propPageSizePreset4x3': 'Ekran 4:3',
	'propPageSizePresetInfographic': 'Infografika',
	'propPageSizeWidth': 'Szerokość',
	'propPageSizeHeight': 'Wysokość',
	'propPageSizeWidthAriaLabel': 'Szerokość strony',
	'propPageSizeHeightAriaLabel': 'Wysokość strony',
	'propPageSizeAdjustedMessage': 'Rozmiar strony został zwiększony, ponieważ wprowadzona wartość była niższa od minimalnej lub strona nie pasowałaby do kokpitu.',
	'propTabShow': 'Pokaż karty',
	'propShowTabsInPreview': 'Pokaż karty w podglądzie',
	'multilingualDashboardsLabel': 'Języki',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- domyślny',
	'multilingualDashboardsAddLinkText': 'Dodaj następny język',
	'multilingualDashboardsSelect': 'Zaznacz',
	'multilingualDashboardsButtonLabel': 'Dodaj',
	'multilingualDashboardTranslationMode': 'Jesteś teraz w trybie tłumaczenia (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Gotowe',
	'multilingualDashboardRemainingStrings': 'Pozostało tłumaczeń: %{numTranslationsLeft}',
	'multilingualDashboardRemainingString': 'Pozostało 1 tłumaczenie',
	'multilingualDashboardsSetDefault': 'Ustaw język domyślny',
	'multilingualDashboardIconMore': 'Więcej czynności dla języka %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Obszar możliwy do przetłumaczenia',
	'multilingualDeleteTitle': 'Usuń język',
	'multilingualDeleteLanguageWarning': 'Czy na pewno chcesz usunąć język \'%{language}\'?',
	'multilingualSelectLanguage': 'Wybierz język',
	'confirmLayoutStyleUpgradeTitle': 'Zastosuj do wszystkich kart',
	'confirmLayoutStyleUpgrade': 'Czy zastosować ten styl układu do wszystkich kart w kokpicie?',

	//Tabs
	'tabDeleteDialogYesButton': 'Tak',
	'tabDeleteDialogNoButton': 'Nie',
	'tabDeleteDialogTitle': 'Usunąć tę kartę?',
	'tabDeleteDialogMessage': 'Cała treść na tej karcie również zostanie usunięta.',

	// Vis widget
	'propVisTypeReturn': 'Typy wizualizacji',
	'propVisDetails': 'Szczegóły',

	// Alignment picker
	'propAlignPickTop': 'Wyrównanie do góry',
	'propAlignPickRight': 'Wyrównanie do prawej',
	'propAlignPickBottom': 'Wyrównanie do dołu',
	'propAlignPickLeft': 'Wyrównanie do lewej',
	'propAlignPickCenter': 'Wyśrodkowanie',
	'propAlignPicker': 'Wyrównywanie',

	// Toolbar picker
	'propToolbarPickBold': 'Pogrubienie',
	'propToolbarPickUnderline': 'Podkreślenie',
	'propToolbarPickItalic': 'Kursywa',
	'propToolbarPickJustifyLeft': 'Wyrównanie do lewej',
	'propToolbarPickJustifyCenter': 'Wyśrodkowanie',
	'propToolbarPickJustifyRight': 'Wyrównanie do prawej',
	'propToolbarPickJustify': 'Wyjustowanie',

	'propList': 'Lista',
	'propOrderedList': 'Lista uporządkowana',
	'propUnorderedList': 'Lista nieuporządkowana',

	// Symbol shapes
	'propCircle': 'Okrąg',
	'propTriangle': 'Trójkąt',
	'propSquare': 'Kwadrat',
	'propRect': 'Prostokąt',
	'propStar': 'Gwiazda',
	'propCross': 'Krzyżyk',
	'propPlus': 'Plus',
	'propPoly': 'Wielokąt',


	// True and false selection
	'propTrue': 'Prawda',
	'propFalse': 'Fałsz',

	// Position selection
	'propLeft': 'Do lewej',
	'propRight': 'Do prawej',
	'propTop': 'Do góry',
	'propBottom': 'Do dołu',

	// Interpolation options
	'propSmooth': 'Wygładź',
	'propStraight': 'Prosto',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Lista', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Przesuń w lewo', // screen reader
	'srWidgetMoveUp': 'Przesuń w górę', // screen reader
	'srWidgetMoveRight': 'Przesuń w prawo', // screen reader
	'srWidgetMoveDown': 'Przesuń w dół', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Powiększ proporcjonalnie', // screen reader
	'srWidgetResizeSmaller': 'Pomniejsz proporcjonalnie', // screen reader
	'srWidgetResizeBiggerV': 'Powiększ pionowo', // screen reader
	'srWidgetResizeSmallerV': 'Pomniejsz pionowo', // screen reader
	'srWidgetResizeBiggerH': 'Powiększ poziomo', // screen reader
	'srWidgetResizeSmallerH': 'Pomniejsz poziomo', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Obróć w prawo', // screen reader
	'srWidgetRotateCCW': 'Obróć w lewo', // screen reader

	// Recommended types
	'visChange': 'Zmień wizualizację',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Wizualizacja',
	'chartLabel': 'Wykres %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Naciśnij F12, aby nawigować w widgecie',
	'f10KeyDescription': 'Naciśnij F10, aby uruchomić widok z aktywnym widgetem',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} z wartością %{value}',

	'shapeColorLabel': 'Kolor kształtu',
	'showLegendLabel': 'Pokaż legendę',

	//Webpage
	'webpageWidgetTitle': 'Widget Strona WWW',
	'webpagePasteLink': 'Wklej adres URL i naciśnij Enter, aby go zapisać',
	'propWebpageLink': 'Adres URL strony WWW',
	'propWebpageTitle': 'Tytuł strony WWW',
	'propWebpageTitleDescription': 'Tytuł strony WWW',
	'propWebpageTop': 'Właściwości strony WWW',
	'webpageMissingUrl': 'Brak adresu URL strony WWW',
	'webpageUrlValidationError': 'Adres URL strony WWW jest niepoprawny',
	'webpageHttpValidationError': 'Aby przeglądarka wyświetliła stronę, dostęp do niej musi być realizowany przez odsyłacz HTTPS',
	'webpageInvalidDomainError': 'Adres URL strony WWW wskazuje na domenę, która nie została zatwierdzona przez administratora. Domeny zatwierdzone przez administratora to "%{domains}"',

	//VizState
	'vzErrorLoading': 'Nie można załadować wizualizacji',
	'vzErrorLoadingMissingData': 'Nie można załadować wizualizacji, brak danych kontekstowych',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Widget multimediów',
	'mediaPasteLink': 'Wklej adres URL i naciśnij Enter, aby go zapisać',
	'videoHeight': 'Wysokość:',
	'videoWidth': 'Szerokość:',
	'propMediaLink': 'Odsyłacz do multimediów',
	'propMediaTitle': 'Tytuł multimediów',
	'propMediaTitleDescription': 'Tytuł multimediów',
	'propMediaTop': 'Właściwości multimediów',
	'mediaMissingUrl': 'Brak odsyłacza URL do multimediów',
	'mediaUrlValidationError': 'Odsyłacz URL do multimediów jest niepoprawny',
	'mediaUnknownValidationError': 'Ten typ multimediów nie jest obsługiwany.',
	'mediaHttpValidationError': 'Aby przeglądarka wyświetliła plik multimedialny, dostęp do niego musi być realizowany przez odsyłacz HTTPS',
	'mediaInvalidDomainError': 'Adres URL pliku multimedialnego wskazuje na domenę, która nie została zatwierdzona przez administratora. Domeny zatwierdzone przez administratora to "%{domains}"',

	// Properties pane
	'commonPropertiesLabel': 'Właściwości',

	// Data strip
	'dataSetsLabel': 'Zestaw danych',
	'dataViewsLabel': 'Widok',
	'columnQuality': 'Jakość danych',
	'columnProperties': 'Właściwości danych',

	'dataQuality': 'Jakość danych',
	'dataQualityRowCount': 'Liczba wierszy',
	'dataQualityDistribution': 'Rozkład',
	'dataRowLabel': 'Dane',

	// Modelling UI
	'typeColumn': 'Typ',
	'modellingColumnType': 'Typ',
	'modellingColumnAggregation': 'Agregacja',
	'modellingColumnUsage': 'Użycie',
	'modellingColumnSort': 'Sortuj',
	'modellingColumnFormat': 'Format',
	'modellingColumnCategory': 'Kategoria',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Ładowanie...',

	'modellingProcessing': 'Przetwarzanie...',
	'modellingImport': 'Importuj',
	'modellingReimport': 'Importuj ponownie',
	'modellingDatasourceTitle': 'Źródło danych',
	'modellingImportStartedTitle': 'Rozpoczęło się importowanie',
	'modellingImportStartedText': 'Importowanie danych może potrwać dłuższy czas.\n\n(W trakcie importowania danych możesz utworzyć widok).',
	'importDatasourceTitle': 'Połączenia',
	'dropHere': 'Upuść tutaj, aby utworzyć nowe źródło danych...',
	'browseButton': 'Przeglądaj',
	'errorNoData': 'Brak danych do przetworzenia.',
	'errorNoFile': 'Brak pliku do przesłania.',
	'errorUploadFailed': 'Przesyłanie niemożliwe.',
	'uploadSucceessful': 'Przesłanie powiodło się',
	'del_datasourceTitle': 'Usuń zestaw danych',
	'del_datasourceMsg': 'Czy na pewno chcesz usunąć \'%{name}\'?',
	'modellingFileUpdate': 'Aktualizuj',
	'modellingFileUpdateTitle': 'Zaktualizuj zestaw danych',
	'modellingFileUpdateDescription': 'Czy chcesz zaktualizować \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Aktualizowanie \'%{name}\'',
	'modellingUpdateStartedTitle': 'Import aktualizujący rozpoczęty',
	'modellingUpdateStartedText': 'Aktualizowanie danych może potrwać dłuższy czas.\n\n(W trakcie aktualizowania danych możesz utworzyć widok).',
	'modellingErrorImportUploadNoFile': 'Brak pliku do przesłania.',
	'modellingErrorImportUploadFailed': 'Przesyłanie niemożliwe.',
	'modellingErrorImportUploadInvalidType': 'Niepoprawny typ pliku.',
	'modellingErrorImportUploadTableFailed': 'Nie można pobrać tabel.',
	'modellingIntentResultsTitle': 'Wybierz proponowany zestaw danych do użycia',
	'modellingColumnViewRelationships': 'Wyświetl tabele pokrewne',
	'modellingTableRelatedTables': 'Tabele pokrewne do \'%{name}\'',
	'modellingTable': '%{name} - tabela',
	'modellingColumnIncludedInDataSet': 'Dodano',
	'modellingDataSet': 'Zestaw danych',
	'modellingViewInDataSet': 'Wyświetl w zestawie danych',
	'modellingViewRelatedTables': 'Wyświetl pokrewne',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Nie znaleziono pokrewnych tabel',

	'modellingValidatingDataset': 'Sprawdzanie poprawności...',
	'datasetFinishedRefreshing': 'Zestaw danych %{datasetName} został odświeżony.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Przetłumacz ścieżkę łączenia:',
	'modellingJoinColumns': 'Zdefiniuj ścieżkę łączenia dla tabeli: %{name}',
	'modellingJoinToTable': 'Połącz z tabelą: %{name}',

	// Data Quality
	'excluded': 'Wykluczone',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Filtr',
	'modellingColumnSortNone': 'Anuluj sortowanie',
	'modellingColumnSortAsc': 'Sortuj rosnąco',
	'modellingColumnSortDesc': 'Sortuj malejąco',
	'modellingColumnRemove': 'Usuń tę kolumnę',

	// Import File Browser
	'dropboxPageTitle': 'Nowe połączenie z Dropbox',
	'sizeColumn': 'Wielkość',

	//Modelling Column Property Values
	'dataType_string': 'Łańcuch',
	'dataType_date': 'Data',
	'dataType_integer': 'Liczba całkowita',
	'dataType_double': 'Podwójna',
	'dataType_float': 'Zmiennopozycyjna',
	'dataType_boolean': 'Wartość boolowska',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Liczebność',
	'defaultAggregation_countdistinct': 'Liczba wartości odrębnych',
	'defaultAggregation_max': 'Maksimum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Średnia',
	'defaultAggregation_sum': 'Suma',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',

	'type_fact': 'Fakt',
	'type_attribute': 'Atrybut',

	'defaultSort_none': 'Nie sortuj',
	'defaultSort_asc': 'Sortuj rosnąco',
	'defaultSort_desc': 'Sortuj malejąco',

	'category_none': 'Brak',
	'category_location': 'Lokalizacja',
	'category_monetary': 'Wartość pieniężna',
	'category_time': 'Godzina',

	// Root menu
	'rootMenuTitle': 'Menu główne',

	'errorMessageTitle': 'Błąd',
	'errorMessageDetails': 'Szczegóły: ',
	'errorMessageTitleAssetAlreadyExists': 'Zasób już istnieje',

	'defaultTabTitle': 'Karta %{index}',
	'tabAddBtnTitle': 'Dodaj nową kartę',

	'unsupportedConditionalFormattingEncountered': 'Formatowanie warunkowe nie jest już stosowane do niektórych kolumn.',


	// Homepage View
	'nameColumn': 'Nazwa',
	'creatorColumn': 'Utworzył(a)',
	'creationDateColumn': 'Data utworzenia',
	'versionColumn': 'Wersja',
	'modifiedColumn': 'Data ostatniej modyfikacji',

	'filterBy': 'Filtruj elementy',
	'allFilter': 'Wszystkie elementy',
	'createdByMeFilter': 'Utworzone przeze mnie',
	'sharedWithMeFilter': 'Udostępnione mnie',
	'favoritesFilter': 'Moje ulubione',
	'recentsFilter': 'Niedawno dodane',
	'sortBy': 'Sortuj wg',

	// Sort Menu
	'sortModified': 'Zmodyfikowane',
	'sortUpdated': 'Zaktualizowano',
	'sortName': 'Nazwa',

	'viewAs': 'Wyświetl jako',
	'thumbnailsView': 'Wyświetl jako miniatury',
	'listView': 'Wyświetl jako listę',
	'createMenu': 'Utwórz',
	'newAppItem': 'Kokpit',
	'newDataSet': 'Zestaw danych',

	'menuSelectionState_a11y': 'Selektor "%{item}" ustawiono na "%{selectedItem}"',

	'unableToShareItem': 'Nie można udostępnić elementu "%{item}".',
	'toastFetchingContent': 'Uzyskiwanie dodatkowej treści...',
	'unableToGetData': 'Nie można uzyskać treści.',
	'unableToFavorite': 'Nie można uzyskać statusu ulubionego.',
	'hpErrorMissingRequiredOptions': 'Brak wymaganych opcji inicjowania',
	'unableToOpenBoard': 'Nie można otworzyć: "%{name}".',
	'unableToDuplicateBoard': 'Nie można powielić: "%{name}".',
	'unableToCreateBoard': 'Nie można utworzyć: "%{name}".',
	'unableToCreateBoardNameConflict': 'Zasób o tej nazwie już istnieje.',

	// DataSet Detail View
	'status': 'Status',
	'numberOfRows': 'Wiersze',
	'importWarnings': 'Ostrzeżenia',
	'lineNumbers': 'Wiersze',
	'excerptFromSource': 'Fragment',
	'reason': 'Przyczyna',
	'numberOfRowsDropped': 'wierszy/-e usunięto',
	'oneRowDropped': 'Usunięto 1 wiersz',

	// Type Menu
	'typeMenuLabel': 'Typ',
	'dashboardsLabel': 'Panele kontrolne',
	'datasetsLabel': 'Zestawy danych',
	'storiesLabel': 'Scenariusze',
	'allLabel': 'Wszystkie typy',

	// Board Page View App Bar
	'datasets': 'Zestawy danych',
	'settings': 'Właściwości',
	'add': 'Dodaj',
	'widgets': 'Widgety',
	'dashboardProperties': 'Właściwości kokpitu',
	'pins': 'Kolekcja',
	'pinsOld': 'Moje przypięcia',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} przypięcie |||| %{smart_count} przyp.',
	'pinSearch': 'Szukaj',
	'pinSearchOld': 'Szukaj przypięć',
	'pinListView': 'Widok listy',
	'pinIconView': 'Widok ikon',
	'pinRemove': 'Usuń',
	'pinCreate': 'Utwórz',
	'pinDeleteError': 'Nie można usunąć jednego lub większej liczby zasobów z kolekcji. Spróbuj ponownie później.',
	'pinDeleteErrorOld': 'Nie można usunąć jednego lub większej liczby przypięć. Spróbuj ponownie później.',
	'pinRetrieveError': 'Nie można pobrać jednego lub większej liczby przypięć. Spróbuj ponownie później.',
	'NoPinsCollected': 'Brak przypiętych wizualizacji',
	'pinDeletedToast': 'Przypięcie zostało usunięte',
	'pinAddedToast': 'Przypięcie zostało pomyślnie dodane do obszaru Moje przypięcia',
	'pinningToast': 'Przetwarzanie przypinania...',
	'pinDateFilter': 'Filtr daty',
	'pinDateFilterAll': 'Wszystko',
	'pinDateFilterToday': 'Dzisiaj',
	'pinDateFilterYesterday': 'Wczoraj',
	'pinDateFilterPastWeek': 'Poprzedni tydzień',
	'pinDateFilterPastMonth': 'Poprzedni miesiąc',
	'pinDateFilterEarlier': 'Wcześniej',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Edytuj tytuł',
	'toolbarActionSort': 'Sortuj',
	'toolbarActionSortAscending': 'Sortuj rosnąco',
	'toolbarActionSortDescending': 'Sortuj malejąco',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionFormat': 'Format',
	'toolbarActionFormatAbbreviation': 'Skracaj',
	'toolbarActionFormatNone': 'Auto',
	'toolbarActionFilter': 'Filtr',
	'toolbarActionTopBottom': 'Od góry lub od dołu',
	'toolbarActionAddShape': 'Dodaj kształt',
	'toolbarActionRmvShape': 'Usuń kształt',
	'toolbarActionToggleShapeDrop': 'Kształt infografiki',
	'toolbarActionToggleShapeDropTitle': 'Utwórz infografikę',
	'toolbarActionToggleShapeDropText': 'Przeciągnij kształt do tego pola, aby utworzyć infografikę.',
	'toolbarActionAggregationType': 'Podsumuj',
	'toolbarDeleteActionText': 'Usuń kolumnę',
	'toolbarActionFilterLocalKeepSelected': 'Zachowaj',
	'toolbarActionFilterLocalExcludeSelected': 'Wyklucz',
	'toolbarActionFilterAllKeepSelected': 'Filtr',
	'toolbarActionSimpleCalculation': 'Proste obliczenie',
	'toolbarActionDrillBack': 'Wstecz',
	'toolbarActionDrillUp': 'Drąż w górę',
	'toolbarActionDrillDown': 'Drąż w dół',
	'toolbarActionNavigate': 'Nawiguj',
	'toolbarActionCreateFilterGroup': 'Utwórz nowe połączenie',
	'toolbarActionDisconnectFilterGroup': 'Przerwij wszystkie odsyłacze',
	'toolbarActionLinkFilterGroup': 'Dodaj do istniejącego połączenia',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Dodaj',
	'sidebarMultiselect': 'Włącz/wyłącz wybór wielu elementów',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': 'Wybrano %{count}',

	'multiselectWithTotalMsg': '%{count} z %{total}',
	'sidebarGoBack': 'Wstecz',

	//DataSet pane
	'errorLoadingDataSets': 'Nie można załadować tego zestawu danych',
	'errorLoadingDataSetMetaData': 'Nie można załadować tego zestawu danych',
	'dataSetPaneLastUpdated': 'Ostatnia aktualizacja: %{date}',
	'dataSetPaneDateUnknown': 'Nieznane',
	'sourcePaneLabel': 'Wybrane źródła',
	'addSourceLabel': 'Dodaj źródło',
	'find_label': 'Znajdź',
	'navigationPathsLabel': 'Ścieżki nawigacji',

	//widgetlist
	'errorLoadingWidgetList': 'Nie można załadować tych obiektów.',
	'errorLoadingThemeFile': 'Nie można załadować definicji kompozycji.',
	'errorLoadingLayoutFile': 'Nie można załadować widoku.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Nie można załadować dostępnych definicji wizualizacji.',

	'dwErrorLoadingVisualizationNotFound': 'Nie można załadować obiektu, ponieważ nie ma w nim definicji wizualizacji',
	'dwErrorLoadingVisualizationListNotFound': 'Nie można załadować wizualizacji.',
	'dwErrorRunningQuery': 'Nie powiodło się pobranie danych z zestawu danych %{datasetName}.',
	'dwErrorGeoData': 'Wystąpił problem z wyświetleniem danych geograficznych na mapie. Wybierz inny typ wizualizacji. ',
	'dwPromptSignonCancelWarning': 'Dane dla wizualizacji są niedostępne. Podaj poprawne dane uwierzytelniające.',
	'dwErrorMissingDataset': 'Nie można załadować wizualizacji, ponieważ nie jest dostępny skojarzony z nią zestaw danych \'%{datasetName}\'.',
	'dwErrorRenderingVisualization': 'Nie można załadować tej wizualizacji.',
	'dwErrorVisualizationTooSmall': 'Wizualizacja jest zbyt mała, by pomieścić dane, które zawiera. Powiększ wizualizację lub ogranicz ilość zawartych w niej danych.',
	'aria_label_datatable': 'Tabela danych',
	'aria_key_navi_datatable_desc': 'Użyj klawiszy strzałek, by nawigować wśród komórek. Naciśnij klawisz Control i Home, aby przejść do pierwszego wiersza, oraz klawisz Control i End, aby przejść do ostatniego wiersza.',
	'geomapUnrecognizedLocations': 'Nierozpoznane lokalizacje:',
	'geomapAmbiguousLocations': 'Regiony niejednoznaczne:',

	// custom widget
	'customWidget': 'Widget niestandardowy',
	'noCustomWidgets': 'Brak widgetów niestandardowych',

	// Action names
	'toggleContextBar': 'Włącz/wyłącz pasek kontekstu',
	'delete': 'Usuń',
	'share': 'Udostępnij',
	'unshare': 'Anuluj udostępnienie',
	'rename': 'Zmień nazwę',
	'close': 'Zamknij',
	'duplicate': 'Duplikuj',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Spróbuj ponownie',

	'changeTemplate': 'Zmień szablon',

	// Aggregation Types
	'sum': 'Suma',
	'count': 'Liczebność',
	'countdistinct': 'Liczba wartości odrębnych',
	'avg': 'Średnia',
	'min': 'Minimum',
	'max': 'Maksimum',
	'custom': 'Niestandardowa',
	'calculated': 'Obliczone',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% zmiany',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Kryteria wizualizacji...',
	'QuickAddResultsHeader': 'Wizualizacje danych',
	'NoQuickAddResults': 'Nie znaleziono wyników. Czy utworzyć nowy zestaw danych?',
	'NoQuickAddResultsRetry': 'Brak wyników wyszukiwania. Spróbuj ponownie z innymi terminami.',
	'templateWidgetTitle': 'Szablon',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(wartość pusta)',

	'nullValueContent': '(brak wartości)',
	'nullValueText': 'Null',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Filtr tekstu - %{columnName}',

	'textFilterSelectTab': 'Zaznacz',

	'textFilterConditionTab': 'Ustaw warunek',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Brak dostępnych elementów.',

	'textFilterEquals': 'Równa się',
	'textFilterContains': 'Zawiera',
	'textFilterBeginsWith': 'Zaczyna się od',
	'textFilterEndsWith': 'Kończy się na',
	'textFilterDoesNotEqual': 'Nie równa się',
	'textFilterDoesNotContain': 'Nie zawiera',
	'textFilterDoesNotBeginWith': 'Nie zaczyna się od',
	'textFilterDoesNotEndWith': 'Nie kończy się na',
	'textFilterSampleText': 'Na przykład: A',

	'textFilterAndButton': 'I',
	'textFilterOrButton': 'Lub',

	'dateFilterMessage': 'Wybierz przedział dat',
	'dateRangeControlRegionLabel': 'Filtr zakresu danych - %{columnName}',
	'dateFilterRangeOption': 'Opcja zakresu',
	'dateFilterDateLabel': 'Data',
	'dateFilterBlank': '(wartość pusta)',
	'dateFilterBefore': 'Przed',
	'dateFilterAfter': 'Po',
	'dateFilterBetween': 'Między',
	'dateFilterSampleText': 'RRRR-MM-DD',
	'dateTitle': 'Data',
	'dateIncludeBlankLabel': 'Uwzględnij puste pole daty',

	'timeTitle': 'Godzina',
	'timeFilterMessage': 'Wybierz przedział godzin',
	'dateTimeFilterMessage': 'Wybierz przedział dat i godzin',

	'topbottomNumberOfResultsLabel': 'Liczba wyników',
	'topbottomPercentLabel': 'Procent',
	'topbottomNumberOfResultsLimit': 'W zakresie %{lower}-%{higher}',
	'topbottomSelectOption': 'Opcja Od góry lub od dołu',
	'topbottomOptionLabel': 'Pokaż',
	'searchByLabel': 'Wg',
	'searchNoMatches': 'Nie znaleziono danych spełniających kryteria',
	'topbottomRankColumnLabel': 'Dodaj kolumnę klasyfikacji do tabeli',
	'topbottomNone': 'Brak',
	'topCount': 'Liczba najwyższych',
	'topPercent': '% najwyższych',
	'bottomCount': 'Liczba najniższych',
	'bottomPercent': '% najniższych',
	'topbottomSearchColumn': 'Znajdź kolumnę',
	'searchColumnAriaLabel': 'Znajdź kolumnę. Wpisz nazwę poszukiwanej kolumny, a następnie użyj strzałki w dół, aby odnaleźć ją na liście.',
	'rankColumnLabel': 'Klasyfikacja (%{columnLabel})',
	'topbottomClearLabel': 'Wyczyść',

	'rangeFilterControlRegionLabel': 'Filtr zakresu - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Kontrolka suwaka. W celu przesuwania uchwytów suwaka użyj strzałek w prawo i lewo',
	'sliderHandleLabel': 'Uchwyt suwaka',
	'a11ySliderHandleLabel': 'Uchwyt suwaka %{sliderValue}',
	'sliderInputLabel': 'wartość',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Niektóre elementy zestawu danych używane w tej wizualizacji są niedostępne.',
	'datasetItemUnavailable': 'Ten element zestawu danych jest niedostępny',

	//Authoring topBottom
	'topOperator': 'Do góry',
	'bottomOperator': 'Do dołu',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} wg %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Tylko ten obiekt',
	'deleteTopBottom': 'Usuń liczbę od góry lub od dołu',
	'editTopBottom': 'Edytuj liczbę od góry lub od dołu',
	'deleteDrillState': 'Usuń bieżący status drążenia',
	'ariaDeleteDrillStateLabel': 'Naciśnij klawisz ENTER, aby edytować liczbę od góry lub od dołu.',
	'drillUpStateTitle': 'Drąż w górę',
	'drillDownStateTitle': 'Drąż w dół',
	'ariaEditTopBottomLabel': 'Naciśnij klawisz ENTER, aby edytować liczbę od góry lub od dołu.',
	'ariaDeleteTopBottomLabel': 'Naciśnij klawisz DELETE, aby usunąć liczbę od góry lub od dołu.',

	// Authoring filtering
	'dimFilterIn': 'Uwzględnia: %{in}',
	'dimFilterNotIn': 'Wyklucza: %{out}',
	'measureFilterBetween': 'Między %{lowerBound} a %{upperBound}',
	'measureFilterNotBetween': 'Nie między %{lowerBound} a %{upperBound}',
	'gtFilter': 'Po %{lowerBound}',
	'ltFilter': 'Przed %{upperBound}',
	'notGtFilter': 'Nie po %{lowerBound}',
	'notLtFilter': 'Nie przed %{upperBound}',
	'localFilterTitle': 'Tylko ten obiekt',
	'globalFilterTitle': 'Wszystkie obiekty',
	'deleteFilter': 'Usuń filtr',
	'editFilter': 'Edytuj filtr',
	'ariaEditFilterLabel': 'Aby edytować filtr, naciśnij klawisz ENTER.',
	'ariaDeleteFilterLabel': 'Aby usunąć filtr, naciśnij klawisz DELETE.',

	// Prompts
	'ariaEditPrompt': 'Naciśnij klawisz ENTER, aby zmienić wartość pytania',

	'moreDataIndicator': 'Twoje dane zostały obcięte przy takiej liczbie pozycji: %{threshold}. Zastosuj filtr, aby wyświetlać mniej.',

	// data point filtering
	'dataPointFilterTitle': 'Punkty danych',
	'dataPointFilterIncludeSummary': 'Uwzględniono punktów danych: %{valueCount}',
	'dataPointFilterExcludeSummary': 'Wykluczono punktów danych: %{valueCount}',

	// DB2 connection page
	'db2Database': 'Baza danych DB2 (%{jdbcConnection})',
	'db2Title': 'Połącz z IBM DB2',

	// Database
	'databaseConnectionMessage': 'Określ dane połączenia z bazą danych:',
	'connectionString': 'Łańcuch połączenia z bazą danych',
	'databaseCredentials': 'Dane uwierzytelniające: ',
	'databaseUserName': 'Nazwa użytkownika',
	'databasePassword': 'Hasło',
	'databaseConnect': 'Połącz',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Wprowadź poszukiwany termin:',
	'twitterKeyword': 'Słowo kluczowe',
	'twitterSearch': 'Szukaj',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Nie można utworzyć widoku: %{error}\nNieudana operacja: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Filtry widgetu',
	'missingColumn': 'Brak: %{columnLabel}',
	'missingFiltering': 'Brak filtrów na kolumnach o następujących identyfikatorach:',
	'heatByLabel': 'Temperatura wg',
	'evColumns': 'Kolumny',
	'evLocalFilters': 'Filtry lokalne',
	'evExpand': 'Rozwiń',
	'evFilterTooltip': 'Filtr',
	'evAdd': 'Dodaj kolumnę',

	// Navigation View
	'navigationBack': 'Wstecz',

	// Pinning
	'contentPinFail': 'Nie można zebrać treści. Spróbuj ponownie później.',
	'contentPinFailOld': 'Nie można przypiąć treści. Spróbuj ponownie później.',

	// Layouts
	'dropZoneLabel': 'Upuść tutaj, aby zmaksymalizować',

	//Share
	'shareDefaultPageTitle': 'Strona %{index}',

	'nextPage': 'Następna strona',
	'previousPage': 'Poprzednia strona',

	'assetAssembly': 'widok',

	'toolbar_save': 'Zapisz',
	'brgr_saveAs': 'Zapisz jako',
	'brgr_refresh': 'Odśwież',

	// Save
	'saving': 'Zapisywanie...',
	'save_success': 'Widok został zapisany.',
	'save_failure': 'Przepraszamy. Zapisanie widoku nie było możliwe. Spróbuj ponownie później.',
	'dashboard_save_success': 'Twój kokpit został zapisany.',

	'geminiLeave': 'Za chwilę wyjdziesz z programu IBM Watson Analytics.',

	'warning': 'Ostrzeżenie',
	'missingDataSetData': 'Dane tego zestawu danych nie są dostępne. Odśwież zestaw danych lub skontaktuj się z administratorem w sprawie dostępu do źródła.',

	// Calculations
	'error_calculation_in_use': 'Wybrane obliczenie jest używane i nie można go usunąć.',

	'resize': 'Zmień rozmiar',
	'rotate': 'Obróć',
	'moveHandle': 'Przenieś widget',
	'expandHandle': 'Rozwiń',
	'panHandle': 'Przesuń',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Nawiguj do',

	// Slide out titles
	'shapeSlideoutTitle': 'Kształty',
	'textSlideoutTitle': 'Tekst',
	'mediaSlideoutTitle': 'Multimedia',
	'visualizationSlideoutTitle': 'Wizualizacje',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Podany kod JSON jest niepoprawny. Więcej informacji zawiera dziennik błędów.',

	// Widget type labels
	'shape_label': 'Kształt',
	'image_label': 'Obraz',
	'data_label': 'Wykres',
	'media_label': 'Multimedia',
	'text_label': 'Tekst',
	'embedMedia_label': 'Multimedia',
	'youtube_label': 'Wideo YouTube',
	'webpage_label': 'Strona WWW',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Kształt',
	'noExtraText_shape_numbered': 'Kształt (%{number})',
	'few_shape': 'Grupa %{count} kształtów',
	'many_shape': 'Grupa %{count} kształtów',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': 'Obraz %{text}',
	'one_image_numbered': 'Obraz %{text} (%{number})',
	'noExtraText_image': 'Obraz',
	'noExtraText_image_numbered': 'Obraz (%{number})',
	'few_image': 'Grupa %{count} obrazów',
	'many_image': 'Grupa %{count} obrazów',
	'noExtraText_text': 'Puste pole tekstowe',
	'noExtraText_text_numbered': 'Puste pole tekstowe (%{number})',
	'few_text': 'Grupa %{count} pól tekstowych',
	'many_text': 'Grupa %{count} pól tekstowych',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': 'Tabela przestawna %{values} na %{row_level1} i %{column_level1}',
	'crosstab_opt_mapping_numbered': 'Tabela przestawna %{values} na %{row_level1} i %{column_level1} (%{number})',
	'crosstab_has_mapping': 'Tabela przestawna %{values} na %{row_level1}',
	'crosstab_has_mapping_numbered': 'Tabela przestawna %{values} na %{row_level1} (%{number})',
	'crosstab_no_mapping': 'Pusta tabela przestawna',
	'crosstab_no_mapping_numbered': 'Pusta tabela przestawna (%{number})',
	'crosstab_named': 'Tabela przestawna %{name}',
	'crosstab_named_numbered': 'Tabela przestawna %{name} (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': 'Tabela %{grid_cols}',
	'JQGrid_has_mapping_numbered': 'Tabela %{grid_cols} (%{number})',
	'JQGrid_no_mapping': 'Pusta tabela',
	'JQGrid_no_mapping_numbered': 'Pusta tabela (%{number})',
	'JQGrid_named': 'Tabela %{name}',
	'JQGrid_named_numbered': 'Tabela %{name} (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': 'Hierarchia %{level1}',
	'hierarchy_has_mapping_numbered': 'Hierarchia %{level1} (%{number})',
	'hierarchy_no_mapping': 'Pusta hierarchia',
	'hierarchy_no_mapping_numbered': 'Pusta hierarchia (%{number})',
	'hierarchy_named': 'Hierarchia %{name}',
	'hierarchy_named_numbered': 'Hierarchia %{name} (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': 'Mapa %{categories}',
	'map_has_mapping_numbered': 'Mapa %{categories} (%{number})',
	'map_no_mapping': 'Pusta mapa',
	'map_no_mapping_numbered': 'Pusta mapa (%{number})',
	'map_named': 'Mapa %{name}',
	'map_named_numbered': 'Mapa %{name} (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': 'Wartość podsumowująca %{actual}',
	'summary_has_mapping_numbered': 'Wartość podsumowująca %{actual} (%{number})',
	'summary_no_mapping': 'Pusta wartość podsumowująca',
	'summary_no_mapping_numbered': 'Pusta wartość podsumowująca (%{number})',
	'summary_named': 'Wartość podsumowująca %{name}',
	'summary_named_numbered': 'Wartość podsumowująca %{name} (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': 'KPI %{actual} na %{sparkline.time}',
	'kpi_opt_mapping_numbered': 'KPI %{actual} na %{sparkline.time} (%{number})',
	'kpi_has_mapping': 'KPI %{actual}',
	'kpi_has_mapping_numbered': 'KPI %{actual} (%{number})',
	'kpi_no_mapping': 'Pusty KPI',
	'kpi_no_mapping_numbered': 'Pusty KPI (%{number})',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': 'Infografika %{actual}',
	'infographicSummary_has_mapping_numbered': 'Infografika %{actual} (%{number})',
	'infographicSummary_no_mapping': 'Pusta infografika',
	'infographicSummary_no_mapping_numbered': 'Pusta infografika (%{number})',
	'infographicSummary_named': 'Infografika %{name}',
	'infographicSummary_named_numbered': 'Infografika %{name} (%{number})',
	'noExtraText_youtube': 'Wideo YouTube',
	'noExtraText_youtube_numbered': 'Wideo YouTube (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': 'Wideo YouTube %{text}',
	'one_youtube_numbered': 'Wideo YouTube %{text} (%{number})',
	'few_youtube': 'Grupa %{count} klipów wideo YouTube',
	'many_youtube': 'Grupa %{count} klipów wideo YouTube',
	'noExtraText_embedMedia': 'Odsyłacz do multimediów',
	'noExtraText_embedMedia_numbered': 'Odsyłacz do multimediów (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': 'Odsyłacz do multimediów %{text}',
	'one_embedMedia_numbered': 'Odsyłacz do multimediów %{text} (%{number})',
	'few_embedMedia': 'Grupa %{count} odsyłaczy do multimediów',
	'many_embedMedia': 'Grupa %{count} odsyłaczy do multimediów',
	'noExtraText_media': 'Multimedia',
	'noExtraText_media_numbered': 'Multimedia (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': 'Multimedia %{text}',
	'one_media_numbered': 'Multimedia %{text} (%{number})',
	'few_media': 'Grupa %{count} multimediów',
	'many_media': 'Grupa %{count} multimediów',
	'noExtraText_webpage': 'Strona WWW',
	'noExtraText_webpage_numbered': 'Strona WWW (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': 'Strona WWW %{text}',
	'one_webpage_numbered': 'Strona WWW %{text} (%{number})',
	'few_webpage': 'Grupa %{count} stron WWW',
	'many_webpage': 'Grupa %{count} stron WWW',
	'one_unknown': 'Obiekt',
	'one_unknown_numbered': 'Obiekt (%{number})',
	'few_unknown': 'Grupa %{count} obiektów',
	'many_unknown': 'Grupa %{count} obiektów',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Dalej',
	'previous': 'Wstecz',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Bieżąca grupa nawigacji: %{navigation_group_name}',

	//Page Context
	'filterBlank': '(wartość pusta)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Nie można załadować wartości filtru',
	'editTimelineHighlight': 'Edytuj podświetlenie',

	'filterDockChevronLeft': 'Przewiń przez dane',
	'filterDockChevronRight': 'Przewiń przez dane',
	'expand': 'Rozwiń',
	'collapse': 'Zwiń',

	//Reset Dashboard
	'dashboardResetTitle': 'Resetuj kokpit',
	'dashboardResetMessage': 'Czy na pewno chcesz cofnąć wszystkie zmiany wprowadzone w tym kokpicie?',
	'dashboardResetToast': 'Kokpit został zresetowany.',

	//Generate PDF
	'buildingPDF': 'Tworzenie pliku PDF...',
	'exportPDF': 'Eksportuj do PDF',
	'pageSize': 'Rozmiar strony',
	'orientation': 'Orientacja',
	'filtersPresentPDF': 'Filtry zastosowane do wizualizacji na poprzedniej stronie:',
	'errorPDF': 'Nie można wygenerować pliku PDF. Odśwież i spróbuj ponownie.',
	'printPDFInfo': 'Wyświetl dokumentację',
	'pdfWidget': 'Widget',
	'includeFilters': 'Pokaż szczegóły filtru',
	'portrait': 'Wydruk pionowy',
	'landscape': 'Wydruk poziomy',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Kokpit został zaktualizowany. Zapisz teraz, aby utrzymać optymalną wydajność.',

	'ariaFullScreenMessage': 'Naciśnij klawisz Escape, aby wyjść z trybu pełnego ekranu',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': 'Upakowany hierarchiczny wykres bąbelkowy %{categories}',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': 'Upakowany hierarchiczny wykres bąbelkowy %{categories} (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Pusty upakowany hierarchiczny wykres bąbelkowy',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Pusty upakowany hierarchiczny wykres bąbelkowy (%{number})',
	'LIVE_hierarchy_packed_bubble_named': 'Upakowany hierarchiczny wykres bąbelkowy %{name}',
	'LIVE_hierarchy_packed_bubble_named_numbered': 'Upakowany hierarchiczny wykres bąbelkowy %{name} (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': 'Wykres marimekko %{categories} na %{values}',
	'LIVE_marimekko_has_mapping_numbered': 'Wykres marimekko %{categories} na %{values} (%{number})',
	'LIVE_marimekko_no_mapping': 'Pusty wykres marimekko',
	'LIVE_marimekko_no_mapping_numbered': 'Pusty wykres marimekko (%{number})',
	'LIVE_marimekko_named': 'Wykres marimekko %{name}',
	'LIVE_marimekko_numbered': 'Wykres marimekko %{name} (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': 'Wykres pierścieniowy %{values}',
	'LIVE_sunburst_has_mapping_numbered': 'Wykres pierścieniowy %{values} (%{number})',
	'LIVE_sunburst_no_mapping': 'Pusty wykres pierścieniowy',
	'LIVE_sunburst_no_mapping_numbered': 'Pusty wykres pierścieniowy (%{number})',
	'LIVE_sunburst_named': 'Wykres pierścieniowy %{name}',
	'LIVE_sunburst_named_numbered': 'Wykres pierścieniowy %{name} (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': 'Wykres analizy czynników %{values}',
	'LIVE_decision_analysis_has_mapping_numbered': 'Wykres analizy czynników %{values} (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Pusty wykres analizy czynników',
	'LIVE_decision_analysis_no_mapping_numbered': 'Pusty wykres analizy czynników (%{number})',
	'LIVE_decision_analysis_named': 'Wykres analizy czynników %{name}',
	'LIVE_decision_analysis_named_numbered': 'Wykres analizy czynników %{name} (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': 'Wykres wierszowo-kolumnowy %{categories} na %{columnValue} i %{lineValue}',
	'LIVE_line_column_opt_mapping_numbered': 'Wykres liniowy %{categories} wobec %{columnValue} i %{lineValue} (%{number})',
	'LIVE_line_column_has_mapping': 'Wykres liniowy i kolumnowy %{columnValue} i %{lineValue}',
	'LIVE_line_column_has_mapping_numbered': 'Wykres liniowy %{categories} wobec %{columnValue} i %{lineValue} (%{number})',
	'LIVE_line_column_no_mapping': 'Pusty wykres wierszowo-kolumnowy',
	'LIVE_line_column_no_mapping_numbered': 'Pusty wykres wierszowo-kolumnowy (%{number})',
	'LIVE_line_column_named': 'Wykres wierszowo-kolumnowy %{name}',
	'LIVE_line_column_named_numbered' : 'Wykres wierszowo-kolumnowy %{name} (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': 'Wykres bąbelkowy %{x} na %{y} i %{size}',
	'LIVE_bubble_chart_has_mapping_numbered': 'Wykres bąbelkowy %{x} na %{y} i %{size} (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Pusty wykres bąbelkowy',
	'LIVE_bubble_chart_no_mapping_numbered': 'Pusty wykres bąbelkowy (%{number})',
	'LIVE_bubble_chart_named': 'Wykres bąbelkowy %{name}',
	'LIVE_bubble_chart_named_numbered': 'Wykres bąbelkowy %{name} (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': 'Wykres punktorowy %{actual}',
	'LIVE_bullet_has_mapping_numbered': 'Wykres punktorowy %{actual} (%{number})',
	'LIVE_bullet_no_mapping': 'Pusty wykres punktorowy',
	'LIVE_bullet_no_mapping_numbered': 'Pusty wykres punktorowy (%{number})',
	'LIVE_bullet_named': 'Wykres punktorowy %{name}',
	'LIVE_bullet_named_numbered': 'Wykres punktorowy %{name} (%{number})',

	// Serviceability
	'generalInfo': 'Ogólne',
	'widgetId': 'Identyfikator widgetu',
	'widgetType': 'Typ widgetu',
	'serviceability': 'Łatwość serwisowania',
	'showInfoForAll': 'Pokaż czas trwania dla wszystkich wizualizacji',
	'hideInfoForAll': 'Ukryj czas trwania dla wszystkich wizualizacji',
	'copyButton': 'Kopiuj',
	'closeButton': 'Zamknij',
	'specification': 'Specyfikacja',
	'viewSpecification': 'Specyfikacja widoku'
});
